// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import {
  deleteFAQ,
  editFAQListStatus,
  fetchFAQList,
} from "../../../Redux/Slices/contentManagementSlice";
// Custom layout
import MainLayout from "../../../Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../Assets";

//utils
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import Modal from "Components/Common/Modal";
import { set } from "react-hook-form";

const FAQs = () => {
  const headerDetails = [
    {
      label: "Questions",
      sortKey: false,
    },
    {
      label: "Answers",
      sortKey: false,
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "status",
        });
      },
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPage = 10;
  const [faqList, setFAQList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [search, setSearch] = useState("");
  const [sortOptions, setSortOptions] = useState({
    sort_by: false,
    order_by: "createdAt",
  });
  // to trigger rerender after status change
  const [staffStatus, setStaffStatus] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [faqToDelete, setfaqToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  //to be used for API Calls

  const changeStatus = (status, id) => {
    console.log(status, id);
    if (status === 1) {
      status = 2;
    } else {
      status = 1;
    }
    dispatch(
      editFAQListStatus({
        data: {
          status: status,
          id: id,
        },
        callBack: faqStatusChangeCB,
      })
    );
  };

  const deleteIndividualFaq = () => {
    if (faqToDelete) {
    dispatch(
      deleteFAQ({
        data: {
          id: faqToDelete,
        },
        callBack: deleteFaqCB,
      })
    );}
    setIsModalOpen(false);
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchFAQList({
        data: {
          search: search,
          page: search ? 1 : currentPage,
          limit: rowsPerPage,
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
        },
        callBack: faqListCB,
      })
    );
  }, [sortOptions, currentPage, staffStatus, search]);

  const faqListCB = (value) => {
    setFAQList(value.data.data_list);
    setTotalPage(value.data.pageMeta.totalPages);
    setIsLoading(false);
  };

  const faqStatusChangeCB = (value) => {
    //triggers rerender after status change
    setStaffStatus(!staffStatus);
    //closes the options menu
    setOpenMenuId(null);
  };

  const openDeleteConfirmationModal = (productId) => {
    setfaqToDelete(productId);
    setIsModalOpen(true);
    setOpenMenuId(null)
  };

  const deleteFaqCB = (value) => {
    console.log(value);
    notifySuccess("FAQ Deleted Successfully");
    //triggers rerender after status change
    setStaffStatus(!staffStatus);
    //closes the options menu
    setOpenMenuId(null);
  };

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);

    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  return (
    <div className="FAQsContainer">
      <div className="FAQsHeader">
        <div className="FAQsHeading">Frequently Asked Questions</div>
         <div className="FAQsSearch">
          <div>
            <InputBox
              value={search}
              icon={assets.Icons.searchIcon}
              onChange={(e) => setSearch(e.target.value)}
              inputStyle={{
                padding: "1px 2vh 1px 7vh",
                border: "none",
                height: "43px",
                width: "25vw",
                borderRadius: "0px",
                borderBottom: "1px solid #C1C7CD",
                boxShadow: "none",
                color: "black",
              }}
            />
          </div>
        <div
          className="FAQsButton"
          onClick={() => navigate("/contentManagement/addFAQs")}
        >
          <Button buttonStyle={{ height: "1vh" }} title="Add New" />
        </div>
        </div>
      </div>
      <div className="FAQsTable">
        <NormalTable
          headerDetails={headerDetails}
          // pagination={true}
        >
          {faqList.length > 0
            ? faqList.map((list) => {
                return (
                  <>
                    <tr
                      key={list.faq_id}
                      className="border"
                      style={{ position: "relative" }}
                    >
                      <td style={{ maxWidth: "11vw", paddingLeft:"1vw" }}>{list.question}</td>
                      <td style={{ maxWidth: "15vw" }}>
                        {list.answer.length > 50
                          ? `${list.answer.slice(0, 50)}...`
                          : list.answer}
                      </td>
                      <td
                        style={{
                          color: `${
                            list.visible_status === 1 ? "#10CA23" : "#FF482F"
                          }`,
                        }}
                      >
                        {list.visible_status === 1 ? "Visible" : "Hidden"}
                      </td>
                      <td>
                        <img
                          style={{ height: "15px", cursor: "pointer" }}
                          src={assets.Icons.optionsIcon}
                          alt="Options"
                          onClick={() => toggleMenu(list.faq_id)} // Open menu for this row
                        />
                        {openMenuId === list.faq_id && (
                          <div className="optionsMenu">
                            <ul>
                              <li
                                onClick={() =>
                                  navigate(
                                    `/contentManagement/viewFAQ/${list.faq_id}`
                                  )
                                }
                              >
                                <img src={assets.Icons.viewIcon} alt="" />
                                View
                              </li>
                              <li
                                onClick={() =>
                                  navigate(
                                    `/contentManagement/editFAQ/${list.faq_id}`
                                  )
                                }
                              >
                                <img src={assets.Icons.editIcon} alt="" />
                                Edit
                              </li>
                              <li
                                onClick={() => openDeleteConfirmationModal(list.faq_id)}
                              >
                                <img src={assets.Icons.deleteIcon} alt="" />
                                Delete
                              </li>
                              <li
                                onClick={() =>
                                  changeStatus(list.visible_status, list.faq_id)
                                }
                              >
                                <img
                                  src={assets.Icons.activeInactiveIcon}
                                  alt=""
                                />
                                Mark as{" "}
                                {list.visible_status === 1
                                  ? "Hidden"
                                  : "Visible"}
                              </li>
                            </ul>
                          </div>
                        )}
                      </td>
                    </tr>
                  </>
                );
              })
             : isLoading ? "Loading..." : "No Data"}
        </NormalTable>
        <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
              <h3 style={{ textAlign:'center', fontFamily:'Roboto' }}>Are you sure you want to delete this FAQ?</h3>
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-around', paddingTop:'20px' }}>
              <Button
              buttonStyle={{
                width: "40%",
                height: "2vh",
              }}
               title='Delete'
               onClick={deleteIndividualFaq }
              />
              <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                    width: "40%",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={() => setIsModalOpen(false)}
                />
            </div>
          </Modal>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default FAQs;
